const donateList = [
  ///  後台用  ///
  {
    unitName: '財團法人台灣兒童暨家庭扶助基金會',
    NPOBAN: '7885'
  },
  ///  後台用  ///
  {
    unitName: '台灣福氣社區關懷協會',
    NPOBAN: '52020'
  },
  {
    unitName: '基督教好牧人全人關顧協會',
    NPOBAN: '6885'
  },
  {
    unitName: '幸福基金會',
    NPOBAN: '1775'
  },
  {
    unitName: '真善美社會福利基金會',
    NPOBAN: '268'
  },
  {
    unitName: '介惠基金會',
    NPOBAN: '05178'
  },
  {
    unitName: '張秀菊社會福利慈善事業基金會',
    NPOBAN: '0303'
  },
  {
    unitName: '甘霖基金會',
    NPOBAN: '1385'
  },
  {
    unitName: '忠義社會福利事業基金會',
    NPOBAN: '25999'
  },
  {
    unitName: '廣青文教基金會',
    NPOBAN: '2581'
  },
  {
    unitName: '路得啟智學園',
    NPOBAN: '1000'
  },
  {
    unitName: '大心社會福利協會',
    NPOBAN: '7025'
  },
  {
    unitName: '台灣盲人重建院',
    NPOBAN: '195185'
  },
  {
    unitName: '微光社會福利協會',
    NPOBAN: '2999'
  },
  {
    unitName: '台灣展翅協會',
    NPOBAN: '5218'
  }
]
export default donateList
